(function ($) {
    $.widget('ca.caButtonDivSelect', {
        hiddenDiv: null,

        options: {
            hiddenDivId: null,
            sortCheckboxes: false,
            titlePlaceholder: '',
            onRemove: function() {},
            checkboxParents: {},
            reloadForm: false
        },

        _init: function () {
            if (this.options.hiddenDivId == null) {
                this.options.hiddenDivId = this.element.attr('id') + '-hidden-div';
            }
            this.hiddenDiv = $('#' + this.options.hiddenDivId);
            
            if (this.options.hideName) {
                if (this.element.find('.value').text().length > 0) {
                    this.element.find('.element-name').hide();
                }
            }
        },

        _create: function () {
            var element = this.element;
            var self = this;
            var options = this.options;

            this._init();

            element.click(function () {
                self._onSelect();
            });

            element.find('.dismiss-input').click(function(ev) {
                self._onRemoveElement(ev);
            });

        },

        _onSelect: function () {
            if (this.element.hasClass('disabled')) {
                return;
            }
            
            currently_hidden = this.hiddenDiv.is(':hidden');

            $('.hidden-filter').hide();
            $('.ca-hidden-div-filter').hide();
            $('.ca-hidden-div-filter-no-fading').hide();

            this._checkboxStatusCheck();

            if (this.options.sortCheckboxes) {
                this._sortCheckboxes();
            }

            if (this.hiddenDiv.is(':hidden')) {
                if (currently_hidden) {
                    this.hiddenDiv.slideToggle(100);
                }
                else {
                    this.hiddenDiv.hide();
                }
            }


            this.hiddenDiv.find('.ca-checkbox-list').scrollTop(0);
        },

        _onRemoveElement: function(ev) {
            if ($(ev.target).parent().attr('id') == 'daterange-select'  && ($('#timein-select').length !== 0 || $('#timeout-select').length !== 0)) {
                ev.stopPropagation();
                return false;
            }
            
            $('.ca-hidden-div-filter-no-fading').hide();

            this.element.parents('.ca-filter-container').remove();

            if (typeof(this.options.onRemove) == 'function') {
                this.options.onRemove(ev);
            } else if (typeof(this.options.onRemove) == 'string' && this.options.onRemove) {
                eval(this.options.onRemove);
            }
            
            ev.stopPropagation();
        },

        _checkboxStatusCheck: function () {
            var checkboxes = this.hiddenDiv.find(':checkbox');
            var self = this;
            $(checkboxes).each(function (ii, ee) {
                var input_container_name = $(ee).attr('input_container_name');
                if (input_container_name) {
                    if ($('.' + input_container_name).length > 0) {
                        $(ee).prop('checked', 'checked');
                    }
                    else {
                        $(ee).removeAttr('checked');
                    }
                }
            });
        },

        _sortCheckboxes: function () {
            var selected_fields_count = 0;
            var self = this;

            var checkbox_groups = this.hiddenDiv.find('.checkbox-group');
            var selected_fields = this.hiddenDiv.find('.selected-fields');

            $(checkbox_groups).each(function (i, e) {
                var checkboxes = $(e).find(':checkbox');
                $(checkboxes).each(function (ii, ee) {
                    var span = $(ee).closest('span');
                    if ($(ee).is(':checked')) {
                        selected_fields_count++;
                        $(span).prependTo(selected_fields);
                    }
                    else {
                        container_name = $(ee).attr('container');
                        $(span).appendTo(self.hiddenDiv.find('.' + container_name));
                    }
                });
            });
            $('.selected-fields-title').hide();
            if (selected_fields_count > 0) {
                $('.selected-fields-title').show();
            }
            $(checkbox_groups).each(function (i, e) {
                var span_checkboxes = $(e).find('span');
                $(span_checkboxes).sort(function (a, b) {
                    var contentA = parseFloat($(a).find(':checkbox').attr('number'));
                    var contentB = parseFloat($(b).find(':checkbox').attr('number'));
                    return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
                }).appendTo(e);
            });
        },

        filter: function(entered_value) {
            var checkboxes = this.hiddenDiv.find(':checkbox');
            $(checkboxes).each(function (ii, ee) {
                span_container = $(ee).closest("span");
                span_text = span_container.text();
                if (span_text.toLowerCase().indexOf(entered_value.toLowerCase()) != -1) {
                    span_container.show();
                } else {
                    span_container.hide();
                }
            });
        },
        groupCheckboxClick: function(checkbox) {
            var checkboxControl = $(checkbox);
            var parentId = checkboxControl.parent().closest('.ca-hidden-div-filter').prop('id').replace('-hidden-div', '');

            var checkboxesContainerValue = 'all-group-type-' + parentId + '-' + checkboxControl.val() + '-fields';

            var checkboxes = checkboxControl.parent().closest('.ca-checkbox-list').find('input[container="' + checkboxesContainerValue + '"]');

            if (checkboxControl.prop('checked')) {
                $(checkboxes).prop('checked', true);
            } else {
                $(checkboxes).prop('checked', false);
            }

            $('#' + parentId).caButtonDivSelect('checkboxClick', checkboxControl);
        },

        checkboxClick: function(checkbox) {
            var class_name = $(checkbox).attr('class');
            var checkboxes = this.hiddenDiv.find('.' + class_name);
            var input_new_name = '';
            var input_addon = '';
            var self = this;

            if (this.element.find('.dismiss-input').length) {
                input_addon = this.element.find('.dismiss-input');
            }
            
            if (!$(checkbox).data('action') || $(checkbox).data('action') != 'group-toggle-checkbox') {
                var parentId = $('div.' + $(checkbox).attr('container')).attr('id');

                if (parentId) {
                    parentId = parentId.replace('-checkbox-container', '');
                }
                
                if (!self.options.checkboxParents[parentId]) {
                    self.options.checkboxParents[parentId] = $('input#' + parentId);
                }

                if (!$(checkbox).is(':checked')) {
                    self.options.checkboxParents[parentId].prop('checked', false);
                } else {
                    $inputs = this.hiddenDiv.find('[container=' + $(checkbox).attr('container') + ']').filter(':checked');

                    if ($inputs.length == self.options.checkboxParents[parentId].data('groupCount')) {
                        self.options.checkboxParents[parentId].prop('checked', true);
                    }
                }
            }
            
            var original_title = '';
            var counter = 0;
            $(checkboxes).each(function (i, e) {
                if ($(e).is(':checked')) {
                    if (!$(e).data('action') || $(e).data('action') != 'group-toggle-checkbox') {
                        var parentId = $('div.' + $(e).attr('container')).attr('id');

                        if (parentId) {
                            parentId = parentId.replace('-checkbox-container', '');
                        }

                        if (!self.options.checkboxParents[parentId]) {
                            self.options.checkboxParents[parentId] = $('input#' + parentId);
                        }

                        if (!self.options.checkboxParents[parentId].is(':checked')) {
                            input_new_name += $(e).attr('name_param') + ', ';
                            counter++;
                        }
                    } else {
                        input_new_name += $(e).attr('name_param') + ', ';  
                        counter++;
                    }
                }
                if (original_title == '') {
                    original_title = $(e).attr('originaltitle');
                }
            });

            if (input_new_name && input_new_name != '' && input_new_name != 'undefined') {
                input_new_name = input_new_name.substring(0, input_new_name.length - 2);
            }
            
            this.element.attr('title', input_new_name);
            
            if (input_new_name.length > 25) {
                input_new_name = input_new_name.substring(0, 25) + "... (" + counter + ")";
            }

            if (input_new_name == '' && this.options.titlePlaceholder) {
                input_new_name = this.options.titlePlaceholder;
            }
          
            this.element.append(input_addon);
            if (input_new_name == '') { input_new_name = original_title; }
            this.element.find('.chosen-single span').text(input_new_name);
            if (this.options.reloadForm == true) {
                this.element.trigger('valuesChanged');
            }
        },
        
        updatePlaceholder: function(checkbox) {
         //   console.log(checkbox);
        },

        updateValue: function(obj) {
            this.hiddenDiv.hide();

            var inputs = this.hiddenDiv.find(":input[type=text]");
            var values = [];
            $(inputs).each(function (i, e) {
                values[i] = e.value;
            });

            this._setValues(values);
        },
        
        updateTimeValue: function(obj) {
            this.hiddenDiv.hide();

            var inputs = this.hiddenDiv.find("select");
            var tempValues = [];
            var values = [];
            $(inputs).each(function (i, e) {
                tempValues[i] = e.value;
            });
            
            var i,j,chunk = 3;
            
            for (i=0,j = tempValues.length; i < j; i += chunk) {
                values.push(tempValues.slice(i,i+chunk).join(":"));
            }

            this._setValues(values);
        },
        
        updateDateValue: function(obj) {
            var values = [];
            var inputs = [];
            this.hiddenDiv.hide();

            if ($("#date_input_type_switcher").length > 0) {
                if ($("#date_input_type_switcher").prop('checked')){
                    inputs = $('#date_range').find(":input[type=text]");

                    $(inputs).each(function (i, e) {
                        values[i] = e.value;
                    });
                } else {
                    inputs = $('#single_date').find(":input[type=text]");

                    $(inputs).each(function (i, e) {
                        values[i] = e.value;
                    });
                }
            } else {
                inputs = this.hiddenDiv.find(":input[type=text]");

                $(inputs).each(function (i, e) {
                    values[i] = e.value;
                });
            }

            this._setValues(values);
        },

        _setValues: function(values) {
            var current_div_value = this.element.html().split("<span")[0];
            current_div_value = $('<div />').html(current_div_value).text(); // get text value without close button div
            var values_string = values.join(' - ');
            if(values[0] == '' && values[1] == '' && this.element.attr('data-empty-title')){
                values_string = this.element.attr('data-empty-title');
            }
            var full_length_text = current_div_value + values_string;
            var current_div_value_length = current_div_value.length;

            this.element.attr('title', values_string);
            if (full_length_text.length > 25) {
                values_string = values_string.substring(0, (25 - current_div_value_length)) + "...";
            }
            this.element.find(".value").text(values_string);
            if (this.options.reloadForm == true) {
                this.element.trigger('valuesChanged');
            }

            if (this.options.hideName) {
                if (values_string.length > 0) {
                    this.element.find('.element-name').hide();
                } else {
                    this.element.find('.element-name').show();
                }
            }
        },

        updateValueLastLogin: function(obj) {
            this.hiddenDiv.hide();

            var text = '';
            var elementId = this.element.attr('id');
            if ($j("#" + elementId + "_value_between").is(':checked')) {
                text = 'Between';
            }
            else if ($j("#" + elementId + "_value_never").is(':checked')) {
                text = 'Never';
            }

            if (text) {
                if (text == 'Between') {
                    var inputs = this.hiddenDiv.find(":input[type=text]");
                    var values = [];
                    $(inputs).each(function (i, e) {
                        values[i] = e.value;
                    });
                } else {
                    var values = [];
                    values[0] = text;
                }

                this._setValues(values);
            }
        },

        clearSelection: function() {
            var self = this;
            var checkboxes = this.hiddenDiv.find(':checkbox');
            $(checkboxes).each(function (i, e) {
                if ($(e).is(':checked')) {
                    $(e).prop('checked', false);
                    self.checkboxClick($(e));
                }
            });
        }

    });
})(jQuery);
